// extracted by mini-css-extract-plugin
export default {"wrapper":"Home_wrapper__53Los","col-right":"Home_col-right__VYd-N","col-left":"Home_col-left__W4PK3"};